// #6587: para onde a UC citada na solicitação pode levar, e quem alcança cada tela.
//
// As regras repetem as do App.tsx (RoleGuard das rotas e o menu do Financeiro).
// Destino que a pessoa não alcança fica escondido: o RoleGuard manda para o painel
// sem aviso, e o link pareceria quebrado.

import { ehGerenteComercial } from '../../src/lib/departamentos.ts';

type PerfilAcesso = {
    role?: string | null;
    permissions?: string[] | null;
    departamento?: string | null;
    departamentos?: string[] | null;
} | null | undefined;

const EMPRESA_PARCEIRA = ['empresa_parceira_admin', 'empresa_parceira_operador'];

// App.tsx (ConsumidorPortalGate e ExternoGeradorasGate) manda esses dois papéis para fora
// de qualquer tela do hub, com ou sem RoleGuard na rota.
const SO_PORTAL = ['consumidor', 'geradoras_externo'];

/** Mesmo recorte do menu: a rota /financeiro abre para mais gente do que o menu mostra. */
export const alcancaFinanceiro = (p: PerfilAcesso): boolean =>
    !!p?.role && !SO_PORTAL.includes(p.role) && !['vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'motoboy'].includes(p.role);

export const alcancaCrm = (p: PerfilAcesso): boolean =>
    !!p?.role && !SO_PORTAL.includes(p.role) && !EMPRESA_PARCEIRA.includes(p.role);

export const alcancaGestao = (p: PerfilAcesso): boolean => {
    if (!p?.role || SO_PORTAL.includes(p.role)) return false;
    const bloqueado = ['vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias', 'gerente', 'motoboy', ...EMPRESA_PARCEIRA].includes(p.role);
    return !bloqueado || !!p.permissions?.includes('modulo:gestao') || ehGerenteComercial(p as never);
};

export interface DestinoUc {
    chave: string;
    rotulo: string;
    rota: string;
}

/** Destinos de Financeiro, já filtrados pela UC (número como está gravado). */
export function destinosFinanceiro(numeroUc: string): DestinoUc[] {
    const n = encodeURIComponent(numeroUc);
    return [
        // meses=todos: sem ele vale o mês que ficou gravado no navegador.
        { chave: 'faturas', rotulo: 'Faturas da UC', rota: `/financeiro/faturas?busca=${n}&meses=todos&abrir=unico` },
        { chave: 'cadastro', rotulo: 'Cadastro da UC', rota: `/financeiro/ucs?busca=${n}&abrir=unico` },
        { chave: 'parcelamentos', rotulo: 'Parcelamentos da UC', rota: `/financeiro/parcelamentos?busca=${n}&status=todos&abrir=unico` },
    ];
}

/** Saldos das UCs (Gestão > Rateio, #6597): a gerente do Comercial só entra na Validação de Dados. */
export const alcancaSaldos = (p: PerfilAcesso): boolean =>
    alcancaGestao(p) && (!ehGerenteComercial(p as never) || !!p?.permissions?.includes('modulo:gestao'));

/** Abre Saldos das UCs já no detalhe da UC (a tela lê `?uc=`). */
export const rotaSaldosUc = (numeroUc: string) => `/gestao/rateio-saldos?uc=${encodeURIComponent(numeroUc)}`;

export const rotaNegociacaoCrm = (id: number | string) => `/crm?negociacaoId=${id}`;
export const rotaNegociacaoGestao = (id: number | string) => `/gestao?negociacaoId=${id}`;
